<template>
  <b-modal class="modal-lg" id="deleteRuleModal" ref="delete-rule-modal" :title="modal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @hide="resetModal">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'trash']" size="1x" class="mr-2"/> {{ modal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <p>{{t('chosenRule', 'chosenRule')}}: <span class="font-weight-bold">#{{modal.ruleData.id}}</span></p>
      <p>{{t('areYouSureYouWantToDelete', 'areYouSureYouWantToDelete')}}</p>
      <ResponseInfo v-if="(getResponseInfo.responseName == 'deleteModal') && (getResponseInfo.status == 'error')"></ResponseInfo>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="modal.modalData">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" aria-label="DeleteRule" data-dismiss="modal" class="btn btn-danger" type="button" @click="deleteRule(modal.ruleData.id)">
          <fontAwesomeIcon :icon="['fa', 'trash']" size="1x" class="mr-2"/>{{ t('deleteRuleButtonText', 'deleteRuleButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'delete_rule_modal',

  inject: [
    'modal',
    'resetModal',
    'refreshResults'
  ],
  data () {
    return {
      buttonIsBusy: false,
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    deleteRule(ruleId) {
      this.$store.dispatch('sendExceptionsStore/deleteSendException', ruleId)
      .then(() => {
        let response = this.getResponseInfo
        if(response.status == 'success') {
          this.refreshResults()
          //this.$store.dispatch('sendExceptionsStore/getSendExceptions')
          this.$refs['delete-rule-modal'].hide()
        }
      })
    }
  },
  created() {
  },
  components:{
    ResponseInfo
  }
}
</script>

<style scoped>

</style>
